import WebApp from "@twa-dev/sdk";

export const getShareLink = async (name, category, copyurl) => {
  try {
    const url =
      "https://t.me/share/url?url=" +
      encodeURI(copyurl) +
      `&text=Let's play, spin, and mine on BitPlay and earn cash rewards and airdrop💰🚁`;
    // WebApp.openTelegramLink(url, { try_instant_view: true });
    window.open(url, "_blank");
  } catch (error) {
    console.log(error);
  }
};
